import React, { useState } from 'react';
import { API_BASE } from '../../App';
import { toast } from 'react-toastify';

function RoomDetailsModal({ match, session, onClose, onSuccess }) {
    const [roomId, setRoomId] = useState(match.room_id || '');
    const [roomPassword, setRoomPassword] = useState(match.room_password || '');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const token = session?.access_token || localStorage.getItem('admin_token');

            const response = await fetch(`${API_BASE}/admin/matches/${match.id}`, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify({
                    room_id: roomId,
                    room_password: roomPassword
                }),
            });

            if (response.ok) {
                toast.success('Room details updated! 🏠');
                onSuccess();
            } else {
                const error = await response.json();
                toast.error(error.message || 'Failed to update room details');
            }
        } catch (error) {
            console.error('Update room error:', error);
            toast.error('Failed to update room details');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '400px' }}>
                <div className="modal-header">
                    <h3 className="modal-title">Room Details</h3>
                    <button className="modal-close" onClick={onClose}>×</button>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label className="form-label">Room ID</label>
                        <input
                            type="text"
                            className="form-input"
                            value={roomId}
                            onChange={(e) => setRoomId(e.target.value)}
                            placeholder="e.g. 1234567"
                        />
                    </div>

                    <div className="form-group">
                        <label className="form-label">Password</label>
                        <input
                            type="text"
                            className="form-input"
                            value={roomPassword}
                            onChange={(e) => setRoomPassword(e.target.value)}
                            placeholder="e.g. 1234"
                        />
                    </div>

                    <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={loading}
                        style={{ width: '100%' }}
                    >
                        {loading ? 'Saving...' : 'Save Details'}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default RoomDetailsModal;
